// extracted by mini-css-extract-plugin
export var fadeIn = "sole-module--fadeIn--hnWVT";
export var sole_main_wrapper = "sole-module--sole_main_wrapper--GRna+";